<template>
  <div id="not-found" class="h-100 w-100 position-absolute">
    <b-container class="h-100">
      <b-row align-v="center" align-h="center" class="h-100">
        <b-col cols="12" md="6" class="text-center">
          <img :src="logo" class="mt-4 w-100" alt="Pettysave Logo" />
          <div class="wrapper my-5">
            <a href="/" class="btn btn-primary d-inline-block btn-lg"
              >Go Home</a
            >
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      logo: require("@/assets/images/404.png")
    };
  }
};
</script>

<style></style>
